import React, { useState, useRef } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Row, Col, InputGroup, Form, Button } from "react-bootstrap"

import "./CashCount.css"
import NavbarAdmin from "../../../Components/NavbarAdmin/NavbarAdmin"
import { createCount } from "../../../Helpers/apiCalls/cashierAPI"
import {
  getFullNameUser,
  getRole,
  numberWithCommas,
  refreshPage,
  removeUserSession,
  toastStyle,
} from "../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import { useReactToPrint } from "react-to-print"
import { logoutUser } from "../../../Helpers/apiCalls/authApi"
import CashCountPrint from "../../../Components/Print/CashCountPrint"
import { printBase64 } from "../../../Helpers/apiCalls/paymentAPI"
import html2canvas from "html2canvas"

function CashCount() {
  const navigate = useNavigate()
  const state = useLocation()
  const [inactive, setInactive] = useState(true)
  const [isClicked, setIsClicked] = useState(false)
  const [billsCount, setBillsCount] = useState([
    {
      label: '1000 bill',
      bill: "1000",
      qty: 0,
      total: 0.0,
    },
    {
      label: '500 bill',
      bill: "500",
      qty: 0,
      total: 0.0,
    },
    {
      label: '200 bill',
      bill: "200",
      qty: 0,
      total: 0.0,
    },
    {
      label: '100 bill',
      bill: "100",
      qty: 0,
      total: 0.0,
    },
    {
      label: '50 bill',
      bill: "50",
      qty: 0,
      total: 0.0,
    },
    {
      label: '20 bill / coin',
      bill: "20",
      qty: 0,
      total: 0.0,
    },
    {
      label: '10 coin',
      bill:"10",
      qty:0,
      total:0.00
    },
    {
      label: '5 coin',
      bill:"5",
      qty:0,
      total:0.00
    },
    {
      label: '1 coin',
      bill:"1",
      qty:0,
      total:0.00
    },
    {
      label: '25 cent',
      bill:"0.25",
      qty:0,
      total:0.00
    },
    {
      label: '10 cents',
      bill:"0.10",
      qty:0,
      total:0.00
    },
    {
      label: '5 cent',
      bill:"0.05",
      qty:0,
      total:0.00
    },
    {
      label: '1 cent',
      bill:"0.01",
      qty:0,
      total:0.00
    },
  ])
  const [coinRemittd, setCoinRemitted] = useState(0)
  const [coinInDrawer, setCoinInDrawer] = useState(0)
  const [billsDrawer, setBillsDrawer] = useState([
    {
      bill: "1000",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "500",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "200",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "100",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "50",
      qty: 0,
      total: 0.0,
    },
    {
      bill: "20",
      qty: 0,
      total: 0.0,
    },
    // {
    //     bill:"10",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"5",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"1",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"0.25",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"0.10",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"0.05",
    //     qty:0,
    //     total:0.00
    // },
    // {
    //     bill:"0.01",
    //     qty:0,
    //     total:0.00
    // },
  ])
  const [totalRemit, setTotalRemit] = useState(0)
  const [totalDrawer, setTotalDrawer] = useState(0)
  const [data, setData] = useState({})

  function Print() {
    var css = "@page {size:legal landscape;}",
      head = document.head || document.getElementsByTagName("head")[0],
      style = document.createElement("style")
    style.type = "text/css"
    style.media = "print"
    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)

    let printContents = document.getElementById("forPrinting").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    logoutUser()
    navigate("/")
    refreshPage()
  }

  async function createCashCount() {
    setIsClicked(true)
    const response = await createCount(
      billsCount,
      billsDrawer,
      coinInDrawer,
      coinRemittd
    )
    if (response.data.status === 200) {
      toast.success(response.data.message.message, {
        style: toastStyle(),
      })
      logoutUser()
      removeUserSession()
      navigate("/")
      refreshPage()
      // handlePrintCashCount()
    }
  }
  const exceptThisSymbols = ["e", "E", "+", "-", "."]
   const handleBillsQtyChange = (e, index, type) => {
    const { value } = e.target;
    let copy = type === "count" ? [...billsCount] : [...billsDrawer];
  
    // Ensure the value is a valid number
    const numericValue = parseFloat(value);
    
    copy[index].qty = value;
    if (!isNaN(numericValue) && value !== "") {
      copy[index].total = (numericValue * parseFloat(copy[index].bill)).toFixed(2);
    } else {
      copy[index].total = (0).toFixed(2);
    }
  
    if (type === "count") {
      setBillsCount(copy);
      setTotalRemit(
        (
          copy.map((data) => parseFloat(data.total)).reduce((a, b) => a + b, 0) +
          parseFloat(coinRemittd)
        ).toFixed(2)
      );
    } else {
      setBillsDrawer(copy);
      setTotalDrawer(
        (
          copy.map((data) => parseFloat(data.total)).reduce((a, b) => a + b, 0) +
          parseFloat(coinInDrawer)
        ).toFixed(2)
      );
    }
  };

  const componentRefCashCount = useRef()
  const handlePrintCashCount = useReactToPrint({
    content: () => componentRefCashCount.current,
    pageStyle: () => "@page { size: letter; margin: 0mm; }",
    onAfterPrint: () => {
      logoutUser()
      navigate("/")
      refreshPage()
    },
  })

  const handleSave = () => {
    setIsClicked(true)
    handlePrint()
    billsCount.map((val) => {
      if (parseFloat(val.bill) >= 20) {
        data[`bill_${val.bill}`] = val.qty
      }
      if (parseFloat(val.bill) < 20 && parseFloat(val.bill) >= 1) {
        data[`coin_${val.bill}`] = val.qty
      }
      if (parseFloat(val.bill) < 1) {
        if (parseFloat(val.bill) === 0.25) {
          data[`cent_25`] = val.qty
        }
        if (parseFloat(val.bill) === 0.1) {
          data[`cent_10`] = val.qty
        }
        if (parseFloat(val.bill) === 0.05) {
          data[`cent_5`] = val.qty
        }
        if (parseFloat(val.bill) === 0.01) {
          data[`cent_1`] = val.qty
        }
      }
    })
    billsDrawer.map((val) => {
      if (parseFloat(val.bill) >= 20) {
        data[`drawer_bill_${val.bill}`] = val.qty
      }
      if (parseFloat(val.bill) < 20 && parseFloat(val.bill) >= 1) {
        data[`drawer_coin_${val.bill}`] = val.qty
      }
      if (parseFloat(val.bill) < 1) {
        if (parseFloat(val.bill) === 0.1) {
          data[`drawer_cent_10`] = val.qty
        }
        if (parseFloat(val.bill) === 0.25) {
          data[`drawer_cent_25`] = val.qty
        }
        if (parseFloat(val.bill) === 0.01) {
          data[`drawer_cent_1`] = val.qty
        }
        if (parseFloat(val.bill) === 0.05) {
          data[`drawer_cent_5`] = val.qty
        }
      }
    })

    data[`count_date`] = new Date().toLocaleDateString("en-US")
    // handlePrint()
  }

  const divId = useRef(null) // Initialize useRef with null
  const [allowPrint, setAllowPrint] = useState(false)

  const handlePrint = () => {
    // setIsClicked(true)
    if (divId.current) {
      const element = divId.current

      // Apply custom CSS for the desired paper size (80mm x 297mm)
      element.style.width = "30%"
      element.style.height = "auto"

      html2canvas(element, { scale: 1 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png")
        printBase64Data(imgData)
      })
    }
  }

  async function printBase64Data(image) {
          createCashCount()

    const response = await printBase64("EPSON TM-T82X Receipt", image, "0")
    if (response.data) {
      setAllowPrint(false)
      setAllowPrint(false)
      setIsClicked(false)
    } else {
      setIsClicked(false)
      toast.error("Error in Printing")
    }
  }

  React.useEffect(() => {
    setTotalDrawer(
      (
        billsDrawer
          .map((data) => parseFloat(data.total))
          .reduce((a, b) => a + b, 0) + parseFloat(coinInDrawer)
      ).toFixed(2)
    )
  }, [coinInDrawer])

  React.useEffect(() => {
    setTotalRemit(
      (
        billsCount
          .map((data) => parseFloat(data.total))
          .reduce((a, b) => a + b, 0) + parseFloat(coinRemittd)
      ).toFixed(2)
    )
  }, [coinRemittd])

  return (
    <div>
      {state?.state?.name !== "cashier" && (
        <NavbarAdmin
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"Cash Count"} //Dashboard navbar index
          page={"Cash Count"}
        />
      )}
      <div
        className={`cash-padding bold-font ${
          getRole() === "2" ? "cashier" : inactive ? "inactive" : "active"
        }`}
        id="forPrinting"
      >
        <Row>
          <Col xl={6}>
            <h3 className="page-title-menu">ADD CASH COUNT </h3>
          </Col>
          {/* <Col xl={6} className="d-flex justify-content-end">
            <button
              className="generate-btn-menu"
              onClick={() => navigate("/x-reading-report")}
            >
              Generate X-Reading
            </button>
          </Col> */}
        </Row>
        <hr />
        <Row className="p-1 b-shadow count-border-cc rounded">
          <Col className="left-div rounded-start cashCount-width">
            <Row className="">
              <Col>
                <h5>
                  <strong>Cash Remitted</strong>
                </h5>
              </Col>
            </Row>
            {billsCount.map((data, index) => {
              return (
                <Row className="mb-2">
                  <Col xs={2}>
                    <label>{data.label}</label>
                  </Col>
                  <Col>
                    <label>x</label>
                  </Col>
                  <Col xs={3}>
                    <InputGroup>
                      <Form.Control
                        type={"number"}
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing"
                        // className='cashRemitted'
                        value={data.qty}
                        onChange={(e) =>
                          handleBillsQtyChange(e, index, "count")
                        }
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                        onWheel={(e) => e.target.blur()}
                        step={1}
                      />
                    </InputGroup>
                  </Col>
                  <Col>
                    <label>=</label>
                  </Col>
                  <Col className="align-right" xs={3}>
                    <label>₱ {numberWithCommas(data.total)}</label>
                  </Col>
                </Row>
              )
            })}
            {/* <Row className="cash-bottom">
              <Col xs={2}>
                <label>Coins</label>
              </Col>
              <Col xs={2}></Col>
              <Col xs={3}>
                <InputGroup>
                  <Form.Control
                    aria-label="Small"
                    aria-describedby="inputGroup-sizing"
                    type={"number"}
                    // className='cashRemitted'
                    min={0}
                    value={coinRemittd}
                    onChange={(e) => setCoinRemitted(e.target.value)}
                  />
                </InputGroup>
              </Col>
              <Col>
                <label>=</label>
              </Col>
              <Col className="align-right" xs={3}>
                <label> ₱ {numberWithCommas(coinRemittd)}</label>
              </Col>
            </Row> */}
            <hr className="p-0 m-0 mb-3" />
            <Row className="d-flex row justify-content-between mb-3">
              <Col>
                <h5>TOTAL</h5>
              </Col>
              <Col className="align-right">
                <h5>
                  <strong>₱ {numberWithCommas(totalRemit)}</strong>
                </h5>
              </Col>
            </Row>
          </Col>
          {/* <Col xs={6} className="cashCount-width">
            <Row className="mb-2">
              <Col>
                <h5>
                  <strong>Cash In Drawer</strong>
                </h5>
              </Col>
            </Row> */}
          {/* {billsDrawer.map((data, index) => {
              return (
                <Row className="cash-bottom">
                  <Col xs={2}>
                    <label>{data.bill}</label>
                  </Col>
                  <Col>
                    <label>x</label>
                  </Col>
                  <Col xs={3}>
                    <InputGroup>
                      <Form.Control
                        aria-label="Small"
                        aria-describedby="inputGroup-sizing"
                        value={data.qty}
                        type={"number"}
                        onChange={(e) =>
                          handleBillsQtyChange(e, index, "drawer")
                        }
                        onKeyDown={(e) =>
                          exceptThisSymbols.includes(e.key) &&
                          e.preventDefault()
                        }
                      />
                    </InputGroup>
                  </Col>
                  <Col>
                    <label>=</label>
                  </Col>
                  <Col className="align-right" xs={3}>
                    <label>₱ {numberWithCommas(data.total)}</label>
                  </Col>
                </Row>
              )
            })} */}
          {/* <Row className="cash-bottom">
              <Col xs={2}>
                <label>Coins</label>
              </Col>
              <Col xs={2}></Col>
              <Col xs={3}>
                <InputGroup>
                  <Form.Control
                    aria-label="Small"
                    aria-describedby="inputGroup-sizing"
                    type={"number"}
                    min={0}
                    value={coinInDrawer}
                    onChange={(e) => setCoinInDrawer(e.target.value)}
                  />
                </InputGroup>
              </Col>
              <Col>
                <label>=</label>
              </Col>
              <Col className="align-right" xs={3}>
                <label> ₱ {numberWithCommas(coinInDrawer)}</label>
              </Col>
            </Row> */}
          {/* <hr className="p-0 m-0 mb-3" />
            <Row className="d-flex row justify-content-between mb-3">
              <Col>
                <h5>TOTAL</h5>
              </Col>
              <Col className="align-right">
                <h5>
                  <strong>₱ {numberWithCommas(totalDrawer)}</strong>
                </h5>
              </Col>
            </Row> */}
          {/* </Col> */}
        </Row>
        <Row className="p-4 mb-3">
          <Col sm={6}></Col>
          <Col sm={3} className="d-flex justify-content-end">
            <Button
              size={"md"}
              variant="info"
              className="button-secondary"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Col>
          <Col sm={3} className="d-flex justify-content-end">
            {totalRemit > 0 ? (
              <Button
                size={"md"}
                variant="success"
                className="button-primary"
                onClick={handleSave}
              >
                Save
              </Button>
            ) : (
              <Button
                size={"md"}
                variant="success"
                className="button-primary"
                disabled
              >
                Save
              </Button>
            )}
          </Col>
        </Row>
        <div ref={divId} className="hide-from-screen">
          <CashCountPrint
            ref={componentRefCashCount}
            billCount={billsCount}
            cashIn={coinInDrawer}
            coinRemittd={coinRemittd}
            coinDrawer={coinInDrawer}
            billDrawer={billsDrawer}
            totalRemit={totalRemit}
            totalDrawer={totalDrawer}
            cashier={getFullNameUser()}
          />
        </div>
      </div>
    </div>
  )
}

export default CashCount
